import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "favourite",
  "use": "favourite-usage",
  "viewBox": "0 0 21 21",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 21 21\" id=\"favourite\"><title>favorite</title><g id=\"favourite__visibility\"><g id=\"favourite_Layer_6-2\" data-name=\"Layer 6\"><path d=\"M10.5316,17.2862a1.32,1.32,0,0,1-.94-.39l-5.18-5.16a4.69,4.69,0,0,1,6.12-7.08,4.69,4.69,0,0,1,6.18,7l-.06.06-5.19,5.19A1.32,1.32,0,0,1,10.5316,17.2862Zm-2.82-12.56a3.69,3.69,0,0,0-2.6,6.28l5.19,5.16a.32.32,0,0,0,.4525.0075l.0075-.0075,5.19-5.16a3.7,3.7,0,0,0,0-5.23h0a3.69,3.69,0,0,0-5.08-.12l-.34.35-.33-.3A3.7,3.7,0,0,0,7.7116,4.7262Z\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/favourite.svg
// module id = hdf1
// module chunks = 4